var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProduction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_10704",
    "data-name": "Grupo 10704",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.386,
    height: 74.832,
    viewBox: "0 0 82.386 74.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4116",
    "data-name": "Trazado 4116",
    d: "M415.559,99.447h-7.1l-6.407-15.616H354.165l-6.4,15.616h-5.926a4.332,4.332,0,0,0,0,8.664h73.721a4.332,4.332,0,1,0,0-8.664Z",
    transform: "translate(-337.505 -33.279)",
    fill: "#0c9cee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4117",
    "data-name": "Trazado 4117",
    d: "M357.637,73.621H351.2L343.5,92.4h21.835Z",
    transform: "translate(-313.811 -73.621)",
    fill: "#0c9cee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4118",
    "data-name": "Trazado 4118",
    d: "M376.451,79.163h-28.94l-5.923,14.445h40.786Z",
    transform: "translate(-321.373 -51.722)",
    fill: "#0c9cee"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProduction);
export default __webpack_public_path__ + "static/media/icon-production.7df41f489dd7522c70d33e10cc9f6c4f.svg";
export { ForwardRef as ReactComponent };